// has path links to pages

export const home = "/"

export const about = "/about"

export const pf_dmg_calc = "/pf_damage_calculator"

export const ticket_booking = "/ticket_booking"

export const pic_32_light = "/pic_32"

export const invoicify = "/invoicify"

export const rock_paper_scissors = "/rock_paper_scissors"

export const pet_adoption_site = "/pet_adoption"

export const discord_bot = "/discord_bot"

export const arabic_letter_card_game = "/arabic_letter_card_game"

export const relit = "/relit"